<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="contact"></progress-components>
      <v-form ref="form" class="mt-12">
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>感染の可能性_インフルエンザ患者の方との接触または身近での流行 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="fulPatientContact"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>感染の可能性_新型コロナウイルス患者の方との接触または身近での流行 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="coronaPatientContact"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <div v-show="hasIntensiveContact == '有'">
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong> 感染の可能性_濃厚接触者② </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
              <div class="mx-4">※感染の可能性_濃厚接触者①で「有」と回答した方のみ</div>
              <div class="mx-4 mb-5">
                ※複数回答可
              </div>
              <v-item-group
                class="mx-2"
              >
                <v-row v-for="(item, index) in selectCause" :key="index">
                  <v-col class="py-0">
                    <v-checkbox
                      :label="item"
                      :value="item"
                      class="py-0 mt-3"
                      dense
                      color="doorMainColor"
                      :hide-details="true"
                      v-model="causeIntensiveContact"
                      :rules="[requiredMultipleSelectIfNeeded(hasIntensiveContact === '有')]"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                    v-model="causeIntensiveContact"
                    color="doorMainColor"
                    value="その他"
                    :hide-details="true"
                    :rules="[requiredMultipleSelectIfNeeded(hasIntensiveContact === '有')]"
                    class="glow mr-1"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="causeIntensiveContactOther"
                    label="その他"
                    variant="underlined"
                    :rules="[requiredOtherTextMultipleSelect(causeIntensiveContact)]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="mx-2 my-1">
                <div v-show="!isValidCause" class="v-messages text-red">
                  <div class="v-messages__message">必ず一つ以上選択してください。</div>
                </div>
              </v-row>
            </v-item-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong> 感染の可能性_感染した可能性のある場所 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
              <div class="mx-4">※感染の可能性_濃厚接触者①で「有」と回答した方のみ</div>
              <div class="mx-4 mb-5">
                ※複数回答可
              </div>
              <v-item-group
                class="mx-2"
              >
                <v-row v-for="(item, index) in selectPlace" :key="index">
                  <v-col class="py-0">
                    <v-checkbox
                      :label="item"
                      :value="item"
                      class="py-0 mt-3"
                      dense
                      color="doorMainColor"
                      :hide-details="true"
                      v-model="placeIntensiveContact"
                      :rules="[requiredMultipleSelectIfNeeded(hasIntensiveContact === '有')]"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                    v-model="placeIntensiveContact"
                    value="その他"
                    color="doorMainColor"
                    :hide-details="true"
                    :rules="[requiredMultipleSelectIfNeeded(hasIntensiveContact === '有')]"
                    class="glow mr-1"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="placeIntensiveContactOther"
                    label="その他"
                    variant="underlined"
                    :rules="[requiredOtherTextMultipleSelect(placeIntensiveContact)]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="mx-2 my-1">
                <div v-show="!isValidPlace" class="v-messages text-red">
                  <div class="v-messages__message">必ず一つ以上選択してください。</div>
                </div>
              </v-row>
            </v-item-group>
          </v-card>
        </div>
      </v-form>
    </v-container>
    <v-container>
     <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNext"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNext"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { Logger } from 'aws-amplify'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useScreenOperation } from '@/func/useScreenOperation'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'
import { useCrossSectional } from '@/const/form/useCrossSectional'
import { useIntensiveContact } from '@/const/form/useIntensiveContact'
import { useFormValidator } from '@/func/useFormValidator'

const logger = new Logger('AdvanceFormIntensiveContact');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    logger.info('AdvanceFormIntensiveContact')
    const form = ref(null)
    const { selectFlagIndicators } = useCrossSectional()
    const { required, requiredMultipleSelectIfNeeded, requiredOtherTextMultipleSelect } = useFormValidator()
    const { scrollToErrorPosition, scrollToTop, fromConfirmScreen, toErrorIfNotExistsId } = useScreenOperation()

    onMounted(() => {
      scrollToTop()
      toErrorIfNotExistsId()
    })
    const fromConfirm = computed(() => fromConfirmScreen())

    const store = useStore()
    const coronaPatientContact = computed({
      get: () => store.state.advanceInterview.coronaPatientContact,
      set: (value) => store.dispatch('advanceInterview/setCoronaPatientContact', value)
    })
    const fulPatientContact = computed({
      get: () => store.state.advanceInterview.fulPatientContact,
      set: (value) => store.dispatch('advanceInterview/setFulPatientContact', value)
    })
    const hasIntensiveContact = computed({
      get: () => store.state.advanceInterview.hasIntensiveContact,
      set: (value) => store.dispatch('advanceInterview/setHasIntensiveContact', value)
    })
    const causeIntensiveContact = computed({
      get: () => store.state.advanceInterview.causeIntensiveContact,
      set: (value) => store.dispatch('advanceInterview/setCauseIntensiveContact', value)
    })
    const causeIntensiveContactOther = computed({
      get: () => store.state.advanceInterview.causeIntensiveContactOther,
      set: (value) => store.dispatch('advanceInterview/setCauseIntensiveContactOther', value)
    })
    const placeIntensiveContact = computed({
      get: () => store.state.advanceInterview.placeIntensiveContact,
      set: (value) => store.dispatch('advanceInterview/setPlaceIntensiveContact', value)
    })
    const placeIntensiveContactOther = computed({
      get: () => store.state.advanceInterview.placeIntensiveContactOther,
      set: (value) => store.dispatch('advanceInterview/setPlaceIntensiveContactOther', value)
    })
    const isValidCause = computed(() => {
      if (hasIntensiveContact.value === '無') {
        return true
      }
      return causeIntensiveContact.value.length > 0
    })
    const isValidPlace = computed(() => {
      if (hasIntensiveContact.value === '無') {
        return true
      }
      return placeIntensiveContact.value.length > 0
    })
    const { selectCause, selectPlace } = useIntensiveContact()
    const router = useRouter()
    const toBack = () => router.go(-1)
    const clickedNext = async () => {
      const result = await form.value.validate()
      if (result.valid) {
        router.push('/interview/confirm')
      } else {
        scrollToErrorPosition()
      }
    }
    return {
      selectFlagIndicators,
      required,
      requiredMultipleSelectIfNeeded,
      requiredOtherTextMultipleSelect,
      form,
      coronaPatientContact,
      fulPatientContact,
      selectCause,
      selectPlace,
      hasIntensiveContact,
      causeIntensiveContact,
      placeIntensiveContact,
      isValidCause,
      isValidPlace,
      clickedNext,
      causeIntensiveContactOther,
      placeIntensiveContactOther,
      toBack,
      fromConfirm
    }
  }
})
</script>

<style scoped>
.v-input :deep(.v-label) {
  color: rgba(0, 0, 0, .87) !important;
}
.v-card-title {
  white-space: inherit !important;
}

@media screen and (max-width: 960px) {
  .btn-area button{
      min-width: 55%!important;
  }
}

</style>
